import { config } from 'util/config';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ sectionComponent } = {}) {
  resetCouncilFilter(sectionComponent);
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  resetCouncilFilter(sectionComponent);
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient.get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (!data.result) return globalFunction.handleResultError(data, pageComponent);
        sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key, formData: data.data });
        sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ ...data.data, ShowSelectedItemsOnly: false });
        const optionLgaList = data.data.OverlayOptionLgaList || [];
        const selectedRowKeys = optionLgaList.map(item => item.LgaId);
        const child = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
        child?.setState({ optionLgaList, selectedRowKeys, defaultSelectedRowKeys: selectedRowKeys, filteredData: child?.state.data || [] });
      })
      .catch((error) => globalFunction.handleError(error, pageComponent));
  }, config.setTimeoutMilliSecond);
}

function resetCouncilFilter(sectionComponent) {
  const customForm = sectionComponent.customForm.current;
  customForm?.formRef.current?.setFieldValue('ShowSelectedItemsOnly', false);
  const child = customForm?.additionalFormRef.current?.child.current;
  child?.setState({ optionLgaList: [], selectedRowKeys: [], defaultSelectedRowKeys: [], filteredData: child?.state.data || [] });
}

export function cancelCustomForm({ sectionComponent } = {}) {
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false, componentType: null });
  setTimeout(() => {
    sectionComponent.customForm.current?.resetFields();
    resetCouncilFilter(sectionComponent);
  }, 300);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent } = {}) {
  const child = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
  child?.setState({ filteredData: parameter ? child.state.data.filter(item => child.state.selectedRowKeys.includes(item.key)) : child.state.data });
}
